module.exports = __webpack_public_path__ + "eeb63739b05cdb0847713d621f388023.svg";